export default [
    {
        path: '/join-categories',
        name: 'join-categories',
        component: () => import ('./pages/Index'),
        meta: {
            title: 'Categoria da Junção',
            icon: 'mdi-vector-triangle',
            breadcrumbs: [
                { text: 'Categoria da Junção', disabled: true }
            ]
        }
    }
]